<script>
  import { getTime } from '../../../common/dates';
  import { addAdminComment } from '../../../Api/api';
  import Button from '../../Common/Button.svelte';
  import { user, singleChatId } from '../../../Store/store';
  import { containsLink, setLink } from '../../../common/utils.js';
  import { createEventDispatcher } from 'svelte';
  import { parseUserId } from '../../../common/utils.js';

  import EmojiSelector from '../../Common/EmojiSelector/index.svelte';

  const dispatch = createEventDispatcher();

  export let comment = null;
  export let channelId = '';

  let textAreaEl;
  let emojiPickerVisible = false;

  $: comment && textAreaEl && textAreaEl.focus();

  let msg = '';

  const answer = async () => {
    if (msg && $user && channelId && comment) {
      await addAdminComment($user, channelId, msg, comment, $singleChatId !== undefined);
      msg = '';
    }
  };

  const onSendAnswerClicked = () => {
    answer();
  };

  const handleKeydown = (e) => {
    if (document.activeElement === textAreaEl) {
      // Enter
      if (e.keyCode === 13) {
        answer();
      }
    }
  };

  const onEmoji = (e) => {
    msg += e.detail;
    emojiPickerVisible = !emojiPickerVisible;
    textAreaEl.focus();
  };

  const addEmiconBtnClicked = async () => {
    emojiPickerVisible = !emojiPickerVisible;
  };
</script>

<svelte:window on:keydown={handleKeydown} />

<div class="answer-input-container">
  {#if comment}
    <div class="comment-container">
      <div class="header">
        <button class="backBtn" on:click={() => dispatch('bckbtnclicked')}
          ><span class="material-icons"> arrow_back </span><span class="txt">Tilbake</span></button
        >
        <h3 class="label">Svar på melding:</h3>
      </div>
      <div class="user-time">
        {getTime(comment.created.toDate())}
        {comment.userName}
        ({parseUserId(comment.userId)})
      </div>
      <span class="content"
        >{#if containsLink(comment.content)}
          {@html setLink(comment.content)}
        {:else}{comment.content}{/if}</span
      >
    </div>
    <div class="answer-container">
      <textarea
        bind:this={textAreaEl}
        bind:value={msg}
        placeholder={`Skriv svar til ${comment.userName} her`}
      />
      <div class="controls">
        <button class="emicons-btn" on:click={addEmiconBtnClicked}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.5 27.5" width="26" height="26"
            ><defs>
              <style>
                .cls-1 {
                  fill: #ffd764;
                }
                .cls-2 {
                  fill: #fff;
                }
                .cls-3 {
                  fill: #af463f;
                }
                .cls-4 {
                  fill: #e86b60;
                }
                .cls-5 {
                  fill: #444545;
                }
              </style>
            </defs>
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <path
                  class="cls-1"
                  d="M13.75,27.5a13.76,13.76,0,1,1,9.72-4A13.76,13.76,0,0,1,13.75,27.5Z"
                />
                <path
                  class="cls-2"
                  d="M21,18.75a7.41,7.41,0,0,0,.25-1.88.61.61,0,0,0-.63-.62H6.87a.61.61,0,0,0-.62.62,7.41,7.41,0,0,0,.25,1.88Z"
                />
                <path class="cls-3" d="M6.5,18.75a7.49,7.49,0,0,0,14.5,0Z" />
                <path
                  class="cls-4"
                  d="M10,23.37a7.43,7.43,0,0,0,7.48,0,4.35,4.35,0,0,0-5.89-1.55A4.37,4.37,0,0,0,10,23.37Z"
                />
                <path
                  class="cls-5"
                  d="M10.62,13.75a.64.64,0,0,1-.3-.08.61.61,0,0,1-.23-.22L8.75,11.23,7.41,13.45a.69.69,0,0,1-.16.18.67.67,0,0,1-.23.1.48.48,0,0,1-.24,0,.63.63,0,0,1-.23-.08.69.69,0,0,1-.18-.16.67.67,0,0,1-.1-.23.48.48,0,0,1,0-.24.63.63,0,0,1,.08-.23L8.22,9.69a.57.57,0,0,1,.23-.2.6.6,0,0,1,.6,0,.57.57,0,0,1,.23.2l1.88,3.11a.59.59,0,0,1,.09.32.65.65,0,0,1-.08.31.57.57,0,0,1-.23.23A.59.59,0,0,1,10.62,13.75Z"
                />
                <path
                  class="cls-5"
                  d="M20.62,13.75a.64.64,0,0,1-.3-.08.61.61,0,0,1-.23-.22l-1.34-2.22-1.34,2.22a.69.69,0,0,1-.16.18.67.67,0,0,1-.23.1.48.48,0,0,1-.24,0,.63.63,0,0,1-.23-.08.69.69,0,0,1-.18-.16.67.67,0,0,1-.1-.23.48.48,0,0,1,0-.24.63.63,0,0,1,.08-.23l1.87-3.11a.68.68,0,0,1,.24-.2.6.6,0,0,1,.6,0,.57.57,0,0,1,.23.2l1.88,3.11a.59.59,0,0,1,.09.32.65.65,0,0,1-.08.31.57.57,0,0,1-.23.23A.59.59,0,0,1,20.62,13.75Z"
                />
              </g>
            </g></svg
          >
        </button>
        <Button on:click={onSendAnswerClicked} disabled={!msg.length}>Send svar</Button>
      </div>
      <EmojiSelector on:emoji={onEmoji} pickerVisible={emojiPickerVisible} />
    </div>
  {:else}
    <div class="choose-msg-container">
      <span class="choose-msg">Velg en melding for å svare på den.</span>
    </div>
  {/if}
</div>

<style src="./answerInput.scss">
</style>
